import CustomFilterSelect from "./CustomFilterSelect";
const FilterAmountOffered = (props: any) => {
  const AmountFilterData = [
    { id: "Paid", name: "Paid" },
    { id: "Unpaid", name: "Unpaid" },
    { id: "No", name: "N/A" },
  ];
  const authrole = localStorage?.getItem("authrole")?.toString();
  return (
    <CustomFilterSelect
      before={props?.before != null && props.before !== "" ? props.before : ""}
      source="appFees"
      label="Application Fees"
      choices={AmountFilterData}
    />
  );
};

export default FilterAmountOffered;
